const DEVICE_KEY = 'clickorico.pos.deviceId';

function randomUuid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getOrCreateDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = randomUuid();
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch {
    return randomUuid();
  }
}

export function isPosOfflineFeatureEnabled() {
  return import.meta.env.VITE_POS_OFFLINE_ENABLED === 'true';
}
